import { useEffect } from 'react';
import type { ProductAttributeCharacteristic } from '../../schema';
import { useEvaluated } from '../../eval/EvalContext';
import { useTranslation } from '../../i18n';
import { formatCalculatedValue } from './formatCalculatedValue';

/**
 * Read-only display of a product-attribute-backed value. Most components
 * keep this Characteristic visibility=hidden (it feeds expressions, not
 * customers), but when shown it surfaces the resolved value only — the
 * attribute name lives in `console.debug` for support.
 */
export function ProductAttributeView({
    characteristic,
}: {
    characteristic: ProductAttributeCharacteristic;
}) {
    const { locale } = useTranslation();
    const result = useEvaluated(characteristic.id);

    useEffect(() => {
        console.debug(
            '[configento] productattribute result',
            characteristic.altTitle || characteristic.id,
            { productAttribute: characteristic.productAttribute, result },
        );
    }, [
        characteristic.id,
        characteristic.altTitle,
        characteristic.productAttribute,
        result,
    ]);

    return (
        <span className="cfg-calc-value" data-configento-eval-result>
            {formatCalculatedValue(result, characteristic.decimalPlace, locale)}
        </span>
    );
}
